// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from 'D:/code/学校考试/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/SmileOutlined';
export default { SmileOutlined };
